import {defineStore} from "pinia";
import {ref} from "vue";
import dayjs from "dayjs";


export const useDelayedStore = defineStore('delayed', () => {
    const isOpened = ref(false);
    const button = ref();
    const delay = ref();
    const afterHours = ref('0');
    const afterMinutes = ref('0');
    const atHours = ref('0');
    const atMinutes = ref('0');
    const dateType = ref();
    const callback = ref(null);

    const reset = () => {
        isOpened.value = false;
        delay.value = 'after';
        afterHours.value = '02';
        afterMinutes.value = '00';
        atHours.value = String(dayjs().add(2, 'hour').hour()).padStart(2, '0');
        atMinutes.value = String(dayjs().minute()).padStart(2, '0');
        dateType.value = 'tomorrow';
        callback.value = null;
    };

    const close = result => {
        isOpened.value = false;
        callback.value && callback.value(result);
    };

    const show = params => new Promise(r => {
        reset();
        if (params && params.button !== undefined) button.value = params.button;
        if (params && params.delay !== undefined) delay.value = params.delay;
        if (params && params.afterHours !== undefined) afterHours.value = params.afterHours;
        if (params && params.afterMinutes !== undefined) afterMinutes.value = params.afterMinutes;
        if (params && params.atHours !== undefined) atHours.value = params.atHours;
        if (params && params.atMinutes !== undefined) atMinutes.value = params.atMinutes;
        if (params && params.dateType !== undefined) dateType.value = params.dateType;

        isOpened.value = true;
        callback.value = r;
    });

    const showWithButton = button => show({button});

    return {
        isOpened,
        button,
        delay, afterHours, afterMinutes,
        dateType, atHours, atMinutes,
        close, show, showWithButton
    };
});
